// @flow

import {fromJS} from 'immutable';

import {defaultFetchDataFormat} from 'app/utils/redux';
import {
  REQUEST_DOCUMENTS_DASHBOARD_LIST,
  RECEIVE_DOCUMENTS_DASHBOARD_LIST,
  RECEIVE_DOCUMENT,
  TOGGLE_DOCUMENTS_DASHBOARD_RELATION,
} from './actions';
import {setNormalizedList} from 'app/utils/redux_v2';
import type {DocumentActionType} from './actions';

const initialState = {
  documents: defaultFetchDataFormat(),
  versions: defaultFetchDataFormat(),
  procedures: defaultFetchDataFormat(),
  processes: defaultFetchDataFormat(),

  // v2 reducers
  byId: {},
  queries: {},
  dashboard: {
    currentFilters: {},
    activeRelations: {},
  },
};

export function documents(
  state: any = fromJS(initialState),
  action: DocumentActionType
): any {
  switch (action.type) {
    case REQUEST_DOCUMENTS_DASHBOARD_LIST:
      return state
        .setIn(['dashboard', 'currentFilters'], fromJS(action.currentFilters))
        .set('isFetching', true);

    case RECEIVE_DOCUMENTS_DASHBOARD_LIST: {
      return setNormalizedList(action.query, action.response, state).set(
        'isFetching',
        false
      );
    }

    case RECEIVE_DOCUMENT: {
      const path = ['byId', action.document.id.toString()];
      return state.setIn(path, action.document);
    }

    case TOGGLE_DOCUMENTS_DASHBOARD_RELATION: {
      const path = ['dashboard', 'activeRelations', action.relation];
      return state.setIn(path, !state.getIn(path));
    }

    default:
      return state;
  }
}
